const getPriceWithDenominator = (priceItem) => {
  if (!priceItem?.amount) return null;
  return priceItem.denominator ? priceItem.amount / priceItem.denominator : priceItem.amount;
};

export default function useGetPrice({ price, new_price, old_price }) {
  if (!price) {
    return { newPrice: new_price, oldPrice: old_price };
  }

  const { regular, discount, loyalty } = price;

  const newPrice =
    getPriceWithDenominator(loyalty) ??
    getPriceWithDenominator(discount) ??
    getPriceWithDenominator(regular) ??
    new_price;
  const oldPrice = getPriceWithDenominator(regular) ?? old_price;

  return { newPrice, oldPrice };
}
